/**
 * Format a dollar-denominated number as a USD currency string.
 * Invoice amounts on PublicInvoiceView are decimal dollars (not cents).
 */
export function formatAmount(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format a 2dp decimal string (e.g. "2691.67") as a USD currency string.
 *
 * PublicInvoiceView.amountPaid and .balanceDue are serialised as strings to
 * preserve exact decimal values without floating-point drift. Parse to a
 * float before formatting — safe here because the value is already rounded
 * to 2dp by the API.
 *
 * Do NOT pass a raw number to this function — use formatAmount() instead.
 */
export function formatAmountStr(amountStr: string): string {
  return formatAmount(parseFloat(amountStr));
}
